import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import createRootReducer from '../reducers';
import { createMiddleware, persistenceMiddleware } from '../fsm/machine';

const configureStore = (initialState, machine) => {
  const baseMiddlewares = [thunk];
  const middlewares = machine
    ? [createMiddleware(machine), persistenceMiddleware(machine), ...baseMiddlewares]
    : baseMiddlewares;
  return createStore(createRootReducer(machine), initialState, applyMiddleware(...middlewares));
};

export default configureStore;
